export default {
    template: document.querySelector('[data-event-calendar-categories-panel]') ?
            document.querySelector('[data-event-calendar-categories-panel]').innerHTML:
            null,
    props: {
        value: {
            type: Number,
        },
        show: {
            type: Boolean,
        },
    },
    data() {
        return {
            selected: this.value,
        }
    },
    watch: {
        value() {
            this.selected = this.value;
        },
    },
    methods: {
        selectCategory(id, label) {
            this.$emit('input', id);
            this.$emit('close');
        },
        selectAll() {
            this.$emit('input', null);
            this.$emit('close');
        },
        setPanelheigth() {
            // set height for animation
            this.$el.style.setProperty('--panel-height', this.$refs.table.getBoundingClientRect().height + 'px');
        }
    },
    mounted() {
        this.setPanelheigth();
        window.addEventListener('resize', this.setPanelheigth)
    }
}